// extracted by mini-css-extract-plugin
export default {"record":"RecordCompareHeaderCard_record__KMv92","disabled":"RecordCompareHeaderCard_disabled__AElK+","header":"RecordCompareHeaderCard_header__UolXW"};